<template>
  <v-menu
    v-model="showPicker"
    :close-on-content-click="false"
    max-width="50%"
    transition="scale-transition"
    offset-y
  >
    <template v-slot:activator="{ on }">
      <ValidationProvider :name="$t(dateName)" :rules="newRule" v-slot="{ errors }">
        <v-text-field
          v-model="pickerDate"
          readonly
          v-on="on"
          :disabled="isConfirm || isAllTextFieldDisabled"
          :error-messages="errors[0]"
          @blur="setRule"
          @keyup.enter="keyupEnter"
        >
          <template v-slot:label>
            <span class="red--text">
              <strong>* </strong>
            </span>
            {{ $t(dateName) }}
          </template>
        </v-text-field>
      </ValidationProvider>
    </template>
    <v-date-picker
      v-model="pickerDate"
      :locale="getLocale"
      @input="showPicker = false"
    ></v-date-picker>
  </v-menu>
</template>

<script>
export default {
  name: 'DatePickerSignDate',
  props: {
    dateName: {
      type: String
    },
    isAllTextFieldDisabled: {
      type: Boolean,
      default: false
    },
    isConfirm: {
      type: Boolean,
      default: false
    },
    fileDate: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      showPicker: false,
      pickerDate: null,
      newRule: ``
    }
  },
  mounted () {
    this.pickerDate = this.fileDate
    this.setRule()
  },
  computed: {
    getLocale () {
      return this.$i18n.locale
    }
  },
  methods: {
    setRule () {
      if (this.fileDate === '') {
        this.newRule = `required`
      } else {
        this.newRule = ``
      }
    },
    keyupEnter (event) {
      this.showPicker = false
      this.$emit('keyupEnter', event)
    }
  },
  components: {},
  watch: {
    pickerDate (newVal) {
      let timestamp = Date.parse(newVal + ' 00:00:00:000')
      this.$emit('setDate', timestamp)
    },
    fileDate (newVal) {
      this.pickerDate = newVal
    }
  }
}
</script>

<style></style>
